<template>
    <div class="ekip-field form-group">
        <slot name="label">
            <label :for="name" class="form-label" :class="labelClasses">{{ label }}
                <span v-if="required" class="text-danger">*</span>
            </label>
        </slot>
        <slot :classes="classes" :error="resolvedError"></slot>
        <div v-if="!!resolvedError || $slots.error" class="invalid-feedback d-block">
            <slot name="error">
                {{ resolvedError }}
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'field',
        provide() {
            return {
                field:this
            }
        },
        props: {
            name: String,
            error: String,
            label: String,
            required: Boolean,
            labelStyle: String,
        },
        data() {
            return {
                localError: null,
                cleaned: false
            }
        },
        computed: {
            classes() {
                return {
                    'is-invalid': !!this.resolvedError
                }
            },
            labelClasses() {
                return {
                    'form-label--default': this.labelStyle === 'default',
                }
            },
            resolvedError() {
                return this.localError || (!this.cleaned && this.error)
            }
        },
        created() {
            this.$on('error', e => this.localError = e);
            this.$on('clean', () => {
                this.localError = null;
                this.cleaned = true;
            });
        }
    }
</script>
